import { render, staticRenderFns } from "./OrganizationCreateView.vue?vue&type=template&id=132e9f75&"
import script from "./OrganizationCreateView.vue?vue&type=script&lang=js&"
export * from "./OrganizationCreateView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports